import React from 'react'
import machine from '../img/machine.jpg'
import Explorebox from './Explorebox'
import ExploreboxAccordian from './ExploreboxAccordian';
import { useNavigate } from 'react-router-dom';


const Explore = (props) => {


    const history=useNavigate();
    const registerPage=(register)=>{
     window.open(register)
    }

    return (
        <>
           <div className="explore">
               <div className="explore__wrapper"></div>
               <div className="explore__content">
                   <div className="explore__left">
                          <img src={props.img} alt="" />
                          <button onClick={()=>registerPage(props.register)}>Register</button>
                          <a href={props.moviet1} download>content</a>
                   </div>
                   {/* /* /////////// */ }
                   <div className="explore__right">
                        <h1>{props.name}</h1>
                        <p>{props.des}</p>
                        <h3>inr {props.cost}</h3>
                           <ExploreboxAccordian name={props.name} date={props.date} duration={props.duration} eligibility={props.eligibility} payment={props.payment} prerequisites={props.prerequisites} certificate={props.certificate} note={props.note} person={props.person} mail={props.mail} contact={props.contact} />
                         <Explorebox name={props.name} date={props.date} duration={props.duration} eligibility={props.eligibility} payment={props.payment} prerequisites={props.prerequisites} certificate={props.certificate} note={props.note} person={props.person} mail={props.mail} contact={props.contact}  />
                   </div>
               </div>
           </div>
        </>
    )
}

export default Explore
